import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    subscribeApi,
} from '../http/http';
import normalizeMsisdn from '../utils/normalizeMsisdn';
import toast, { Toaster } from 'react-hot-toast';
import classes from './SubscribePage.module.css';

const PLANS = [
    { id: 'DAILY', name: 'Daily', price: 'NGN 50', duration: '/day' },
    { id: 'WEEKLY', name: 'Weekly', price: 'NGN 100', duration: '/week' },
];

const SubscribePage = () => {
    const [phone, setPhone] = useState('');
    const [selectedPlan, setSelectedPlan] = useState(49);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleStartSubscription = async (e) => {
        e.preventDefault();

        const normalizedMsisdn = normalizeMsisdn(phone);
        if (!normalizedMsisdn) {
            toast.error('Please enter a valid Nigerian mobile number');
            return;
        }

        if (!selectedPlan) {
            toast.error('Please select a subscription plan');
            return;
        }

        setLoading(true);
        const loadingToast = toast.loading('Starting subscription...');

        try {
            const response = await subscribeApi(normalizedMsisdn, selectedPlan);
            const data = response.data?.data || {};
            const flow = { msisdn: data.msisdn || normalizedMsisdn, packType: data.packType || selectedPlan, trxId: data.trxId, startedAt: Date.now() };
            sessionStorage.setItem('subscriptionFlow', JSON.stringify(flow));
            window.open(data.redirectUrl, '_blank', 'noopener,noreferrer');
            toast.success('Continue in the VDL window.', { id: loadingToast });
            navigate('/subscribe/waiting');
        } catch (err) {
            const backendMsg = err.response?.data?.message || 'Something went wrong. Please try again.';
            toast.error(backendMsg, { id: loadingToast });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={classes.page_wrapper}>
            <Toaster position="top-center" reverseOrder={false} />

            <div className={classes.bg_blob_1}></div>
            <div className={classes.bg_blob_2}></div>

            <div className={classes.card}>
                <div className={classes.logo_area}>
                    <div className={classes.logo_icon_wrap}>
                        <img src="/assets/images/logo.png" alt="GamePlex logo" className={classes.logo_icon} />
                    </div>

                    <p className={classes.logo_text}>Game<span>Plex</span></p>
                </div>

                <div className={classes.heading_area}>
                    <h1 className={classes.title}>Subscribe to start playing</h1>
                    <p className={classes.subtitle}>Choose a plan and verify your mobile number.</p>
                </div>

                <form className={classes.form} onSubmit={handleStartSubscription}>
                    <div className={classes.field_wrapper}>
                        <label className={classes.field_label}>MSISDN</label>
                        <div className={classes.input_group}>
                            <span className={classes.input_prefix}>+234</span>
                            <input
                                className={classes.input}
                                type="tel"
                                placeholder="8012345678"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
                                maxLength={14}
                                disabled={loading}
                            />
                        </div>
                    </div>

                    <div className={classes.plan_section}>
                        <div className={classes.plan_section_header}>
                            <label className={classes.field_label}>CHOOSE PLAN</label>
                        </div>

                        <div className={classes.pack_cards}>
                            {PLANS.map((plan) => {
                                const isSelected = selectedPlan === plan.id;

                                return (
                                    <button
                                        key={plan.id}
                                        type="button"
                                        className={`${classes.pack_card} ${isSelected ? classes.pack_card_selected : ''}`}
                                        onClick={() => setSelectedPlan(plan.id)}
                                        disabled={loading}
                                    >
                                        <div className={classes.pack_card_top}>
                                            <span className={classes.pack_title}>{plan.name}</span>
                                            <span className={`${classes.radio_circle} ${isSelected ? classes.radio_circle_selected : ''}`}>
                                                {isSelected && '✓'}
                                            </span>
                                        </div>

                                        <div className={classes.pack_price}>{plan.price}<span>{plan.duration}</span></div>
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    <button type="submit" className={classes.submit_btn} disabled={loading}>
                        {loading ? 'Starting...' : 'Continue'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default SubscribePage;